import PropTypes from 'prop-types';

export const APPLE_AUTHENTICATION_DATA_PROPTYPES = PropTypes.shape({
    idToken: PropTypes.string.isRequired,
    isEmailHidden: PropTypes.bool.isRequired,
    isUser: PropTypes.bool.isRequired,
    expirationTimestamp: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    externalIdentities: PropTypes.object,
});
